import React from "react";
import Alert from "./Alert";

export default function ErrorState({ message = "Something went wrong.", onRetry }) {
  return (
    <div style={{ padding: 24, maxWidth: 400, margin: "0 auto" }}>
      <Alert variant="error" style={{ marginBottom: 16 }}>
        {message}
      </Alert>
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          style={{
            padding: "var(--sp-2) var(--sp-4)",
            background: "var(--bg2)",
            border: "1px solid var(--bdr)",
            borderRadius: "var(--sp-2)",
            color: "var(--t1)",
            fontSize: 12,
            fontWeight: 600,
            cursor: "pointer",
            fontFamily: "'Outfit', sans-serif",
          }}
        >
          Try again
        </button>
      )}
    </div>
  );
}
